import { useMutation, useQueryClient } from 'react-query';
import { getSubscriptionBlockUseCases } from '@subscriptions/composition';
import type { UpdateBlockInvoiceDataDto, SubscriptionBlockViewDto } from '@subscriptions/application/dtos';

/**
 * Hook for updating the invoice data of a subscription block.
 *
 * @returns Mutation result for updating block invoice data
 */
export const useUpdateBlockInvoiceData = () => {
  const queryClient = useQueryClient();
  const { updateBlockInvoiceData } = getSubscriptionBlockUseCases();

  return useMutation<SubscriptionBlockViewDto, Error, { blockUuid: string; dto: UpdateBlockInvoiceDataDto }>(
    ({ blockUuid, dto }) => updateBlockInvoiceData.execute(blockUuid, dto),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(['subscriptions', 'blocks']);
      },
    },
  );
};
